import React from 'react'
import SearchInput from '../../containers/searchpage-search-input'

const MiniSearchbar = () => {
  return <SearchInput />
}

export default MiniSearchbar
